import { CheckCircleIcon } from '@heroicons/react/solid';

const includedFeatures = [
  'Clear value of AI for your business and activities',
  'Solutions tailored to specific business needs',
  '3 hours of hands-on practice',
  'Networking opportunities',
  'Post-workshop support',
  'Unlimited Plan access (1 month, US$28 value)',
  'Lucky draw',
  'Coffee, tea, and refreshments',
];

export default function SinglePrice() {
  return (
    <section className='border-t border-slate-100 bg-slate-50 py-24 dark:border-slate-900 dark:bg-slate-950 sm:py-32'>
      <div className='mx-auto max-w-7xl px-6 lg:px-8'>
        <div className='mx-auto max-w-2xl text-center'>
          <h2 className='text-base font-semibold leading-7 text-indigo-600 dark:text-indigo-500'>
            Reserve Your Seat
          </h2>
          <p className='mt-2 text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-100 sm:text-4xl'>
            How To Make AI Work For You?
          </p>
          <p className='mt-4 text-lg leading-8 text-slate-600 dark:text-slate-400'>
            An interactive session built to empower business owners like you
            with the knowledge and tools to integrate AI seamlessly into your
            work.
          </p>
        </div>

        <div className='mx-auto mt-16 max-w-2xl overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-slate-200 dark:bg-slate-900 dark:ring-slate-800 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none'>
          <div className='p-8 sm:p-10 lg:flex-auto'>
            <h3 className='text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-100'>
              3-Hour Workshop, In Person
            </h3>
            <p className='mt-6 text-base leading-7 text-slate-600 dark:text-slate-400'>
              Grab your laptop and join us for a hands-on workshop that unlocks
              new horizons of innovation and creativity. See you there!
            </p>
            <div className='mt-10 flex items-center gap-x-4'>
              <h4 className='flex-none text-sm font-semibold leading-6 text-indigo-600 dark:text-indigo-500'>
                What&apos;s included
              </h4>
              <div className='h-px flex-auto bg-slate-200 dark:bg-slate-800' />
            </div>
            <ul
              role='list'
              className='mt-8 grid grid-cols-1 gap-4 text-sm leading-6 text-slate-700 dark:text-slate-300 sm:grid-cols-2 sm:gap-x-6'
            >
              {includedFeatures.map((feature) => (
                <li key={feature} className='flex items-start gap-x-3'>
                  <CheckCircleIcon
                    className='mt-0.5 h-5 w-5 flex-none text-indigo-600 dark:text-indigo-500'
                    aria-hidden='true'
                  />
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          <div className='lg:w-full lg:max-w-md lg:flex-shrink-0'>
            <div className='flex h-full flex-col justify-center bg-slate-50 p-8 text-center dark:bg-slate-800/40 lg:p-12'>
              <div className='mx-auto max-w-xs'>
                <p className='text-sm font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400'>
                  One all-inclusive price
                </p>
                <p className='mt-4 flex items-baseline justify-center gap-x-2'>
                  <span className='text-5xl font-extrabold tracking-tight text-slate-900 dark:text-white'>
                    $58
                  </span>
                  <span className='text-sm font-semibold leading-6 tracking-wide text-slate-500 dark:text-slate-400'>
                    SGD
                  </span>
                </p>
                <a
                  href='https://buy.stripe.com/bIYbKTcWN3XT1J6eV8'
                  className='mt-8 block w-full rounded-xl bg-indigo-600 px-3.5 py-3 text-center text-sm font-bold text-white shadow-sm transition-all duration-150 hover:bg-indigo-500 hover:shadow focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                >
                  I Want To Make AI Work For Me
                </a>
                <p className='mt-6 text-xs leading-5 text-slate-500 dark:text-slate-400'>
                  After submission you will be redirected to secure Stripe
                  checkout. Choose your workshop date on the registration page.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
